import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["darkIcon", "lightIcon", "label"]

  connect() {
    this.updateUI()
  }

  toggle() {
    const isDark = document.documentElement.classList.contains("dark")
    document.documentElement.classList.toggle("dark", !isDark)
    this.updateUI()

    post("/account/toggle_dark_mode")
  }

  updateUI() {
    const isDark = document.documentElement.classList.contains("dark")

    if (this.hasDarkIconTarget) {
      this.darkIconTarget.classList.toggle("hidden", isDark)
    }
    if (this.hasLightIconTarget) {
      this.lightIconTarget.classList.toggle("hidden", !isDark)
    }
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = isDark ? "Light mode" : "Dark mode"
    }
  }
}
